import { Box, Button, Dialog, DialogActions, DialogContent, IconButton, Theme, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { CheckedRadio, DialogCloseIcon, UncheckRadio } from "../../../../assets/SvgIcons";
import CustomTable from "../../common/customTable";
import { TableHeaderData } from "../../types";
import { useDispatch, useSelector } from "react-redux";
import { RootStateType } from "../../../../redux-store/reducers";
import { getMandatesList } from "../../../../redux-store/actions/investorProfile";
import { MandateListItem, MandatesListResBody } from "../../../../redux-store/types/investorProfile";
import { MandateTableBody } from "../../transcation/Mandate";
import { LoadingButton } from "@mui/lab";
import MandateCreationForm from "../../transcation/MandateCreationForm";

const tableHeaderData: TableHeaderData[] = [
    {
        id: "checkbox",
        label: "",
        align: "left",
        isSortable: false
    },
    {
        id: "bankName",
        label: "BANK NAME",
        align: "center",
        isSortable: false
    },
    {
        id: "accountNumber",
        label: "ACCOUNT NUMBER",
        align: "center",
        isSortable: false
    },
    {
        id: "amount",
        label: "AMOUNT",
        align: "center",
        isSortable: false
    },
    {
        id: "mandateId",
        label: "MANDATE ID",
        align: "center",
        isSortable: false
    },
    {
        id: "startDate",
        label: "START DATE",
        align: "center",
        isSortable: false
    },
    {
        id: "endDate",
        label: "END DATE",
        align: "center",
        isSortable: false
    },
    {
        id: "status",
        label: "STATUS",
        align: "center",
        isSortable: false
    },
]

export default function SwitchMandate
    (
        {
            mandateSwitchDialog,
            handleSwitchMandatePopup,
            clientCode,
            activeRowAmount,
            activeRowMandId = "",
            selectedMandateId,
            setSelectedMandateId,
            handleActiveMandate,
            mandateSwitchLoader,
            handleCreateMandate,
            mandateCreationLoading,
        }:
            {
                mandateSwitchDialog: boolean,
                handleSwitchMandatePopup: () => void,
                clientCode: string,
                activeRowAmount: number | string,
                helperPayloadObj?: { [key: string]: any }
                activeRowMandId?: string
                handleActiveMandate?: () => void
                selectedMandateId: string
                setSelectedMandateId?: (mandateId: string) => void
                mandateSwitchLoader: boolean
                setMandateSwitchLoader?: (value: boolean) => void
                handleCreateMandate?: (value: any, mandateObj: any) => void
                mandateCreationLoading: boolean
                setMandateCreationLoading?: (value: boolean) => void
            }
    ): JSX.Element {
    const theme = useTheme();
    const { investorClientId = "" } = useSelector((store: RootStateType) => store.id);
    const { selectedPortfolio } = useSelector((state: RootStateType) => state.selectedPortfiolio);
    const dispatch = useDispatch();
    const [filterMandatesList, setFilterMandatesList] = useState<MandateListItem[]>([])
    const [mandatesLoading, setMandatesLoading] = useState<boolean>(false);


    const mandateDialogOptions = [
        {
            id: 0,
            label: 'Active Mandates',
            value: 'approvedMandates'
        },
        {
            id: 1,
            label: 'Create New Mandate',
            value: 'createNewMandate'
        },

    ]
    const [curMandateOption, setCurMandateOption] = useState<number>(mandateDialogOptions[0].id);

    const handleClose = () => {
        console.log('closing');
    }
    const handleSelectMandateRadioBtn = (mandateId: string) => {
        setSelectedMandateId?.(mandateId);
    }

    useEffect(() => {
        const fetchActiveMandates = async () => {
            try {
                setMandatesLoading(true);
                const mandatesListRes = await (dispatch(getMandatesList({ amount: activeRowAmount, clientCode: clientCode || investorClientId, status: "Active", portfolioId: selectedPortfolio?.value })) as unknown as Promise<MandatesListResBody>);
                const filterCurMandId = mandatesListRes?.mandates?.filter((mandate) => mandate.mandateId !== activeRowMandId);
                setFilterMandatesList(filterCurMandId ?? []);
            } catch (e) {
                console.warn('Error', e);
            } finally {
                setMandatesLoading(false);
            }

        }
        if (curMandateOption === mandateDialogOptions[0].id) {
            fetchActiveMandates();
        }
    }, [])
    return (
        <>
            <Dialog
                open={mandateSwitchDialog}
                maxWidth='md'
                onClose={handleSwitchMandatePopup}
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: { xs: '10px', sm: '15px' },
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "8px",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            // paddingBottom: 1.5,
                            borderBottom: `1px solid ${theme.palette.text.primary}B2`,
                        }}
                    >
                        <Typography variant="body_500" color="text.primary">Switch Mandate</Typography>
                        <IconButton
                            aria-label="close"
                            onClick={handleSwitchMandatePopup}
                            sx={{
                                padding: "5px"
                            }}
                        >
                            <DialogCloseIcon />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            gap: '10px',
                            // mb: 1,
                            // mt: 2,
                            pb: 2,
                            borderBottom: `1px solid ${theme.palette.text.secondary}80`,
                        }}>
                        {mandateDialogOptions?.map((item) => (
                            <Button
                                key={item.id}
                                component={'button'}
                                sx={{ display: 'flex', alignItems: 'center', gap: '10px', borderRadius: '10px', border: `1px solid ${theme.palette.text.secondary}80`, padding: { xs: '5px 10px', sm: '5px 10px' }, width: 'fit-content', background: item.id === curMandateOption ? theme.palette.primary[500] + '1A' : 'transparent', cursor: 'pointer' }}
                                onClick={() => setCurMandateOption(item.id)}
                            >
                                {item.id === curMandateOption ? <CheckedRadio /> : <UncheckRadio />}
                                <Typography
                                    variant="body_500"
                                    color={item.id === curMandateOption ? theme.palette.primary[500] : theme.palette.text.secondary}
                                >
                                    {item.label}
                                </Typography>
                            </Button>
                        ))}
                    </Box>
                    {curMandateOption === 0 && (
                        <>
                            <DialogContent
                                sx={{
                                    maxHeight: "100%",
                                    overflowY: "auto",
                                    padding: "10px 20px 10px 10px"
                                }}
                            >
                                <CustomTable
                                    isLoading={mandatesLoading}
                                    loadingRowsNum={2}
                                    tableBody={
                                        <MandateTableBody
                                            data={filterMandatesList}
                                            selectedMandateId={selectedMandateId}
                                            handleRadioBtnClick={handleSelectMandateRadioBtn}
                                        />
                                    }
                                    tableData={filterMandatesList}
                                    tableHeaderData={tableHeaderData}
                                    tableDataCount={(filterMandatesList ?? []).length}
                                    tableBodyLoaderRowCustomStyles={{
                                        '& td:first-of-type': {
                                            paddingLeft: "0px"
                                        },
                                    }}
                                    tableHeadRowCustomStyles={{
                                        '& th:first-of-type': {
                                            paddingLeft: "0px"
                                        }
                                    }}
                                    tableBodyCustomStyles={{
                                        '& tr:last-child td': {
                                            border: 0
                                        },
                                    }}
                                    isPaginationVisible={false}
                                />
                            </DialogContent>
                            <DialogActions
                                sx={{ justifyContent: "center" }}
                            >
                                <LoadingButton
                                    variant="contained"
                                    loading={mandateSwitchLoader}
                                    sx={(theme: Theme) => ({
                                        ...theme.typography.body_600,
                                        padding: "10px",
                                        width: "50%"
                                    })}
                                    // onClick={() => handleMandateSelection(selectedMandateId, selectedMandateStatus, mandateCreationDate, activeMandateObj)}
                                    onClick={handleActiveMandate}
                                >
                                    Submit
                                </LoadingButton>
                            </DialogActions>
                        </>
                    )}
                    {curMandateOption === 1 && (
                        <>
                            <DialogContent
                                sx={{
                                    maxHeight: "100%",
                                    overflowY: "auto",
                                }}
                            >
                                <MandateCreationForm
                                    clientCode={clientCode}
                                    onClose={handleClose}
                                    handleCreateMandateStatus={handleCreateMandate}
                                    prefilledValues={{}}
                                    mandateCreationLoading={mandateCreationLoading}
                                    comingFromSysPlan={true}
                                />
                            </DialogContent>
                        </>
                    )}
                </Box>
            </Dialog>
        </>
    )
}